import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Update } from '../models/update.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  private apiUrl = environment.apiUrl + environment.update;

  constructor(private http: HttpClient) {}

  getUpdates(): Observable<Update[]> {
    return this.http.get<Update[]>(`${this.apiUrl}`);
  }

  getUpdateByTypeAndArea(type: string, area: string): Observable<Update[]> {
    return this.http.get<Update[]>(`${this.apiUrl}/type/${type}/area/${area}`);
  }
}
